// --- START OF FILE src/pages/LoginForm.jsx ---

import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { signInWithEmailAndPassword, setPersistence, browserLocalPersistence, browserSessionPersistence } from 'firebase/auth';
import { useTranslation } from 'react-i18next'; // MODIFICACIÓN: Importar useTranslation
import { auth } from '../firebase';
import '../styles/LoginForm.css';
import Envelope from '../icons/Envelope';     
import EyeSlash from '../icons/EyeSlash';   
import Visibility from '../icons/Visibility'; 

function LoginForm({ onLoginSuccess }) {
  const { t } = useTranslation(); // MODIFICACIÓN: Hook de traducción
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true); 
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true); 
    try {
      const persistenceType = rememberMe ? browserLocalPersistence : browserSessionPersistence;
      await setPersistence(auth, persistenceType);
      await signInWithEmailAndPassword(auth, email, password);
      onLoginSuccess();
    } catch (err) {
      setError(t('invalidCredentialsError')); // MODIFICACIÓN
      console.error("Login error:", err);
      setIsSubmitting(false); 
    }
  };

  return (
    <div className="screen">
      <div className="login-container">
        <div className="login-logo">
          <img src="/Reseye Logo.png" alt={t('logoAltText')} /> {/* MODIFICACIÓN */}
        </div>
        <div className="login-form">
          <form onSubmit={handleSubmit}>
            <h2>{t('loginPageTitle')}</h2> {/* MODIFICACIÓN */}
            <p>{t('loginPageSubtitle')}</p> {/* MODIFICACIÓN */}
            <div className="input-group">
              <label htmlFor="email">{t('emailAddressLabel')}</label> {/* MODIFICACIÓN */}
              <div className="input-with-icon">
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isSubmitting} 
                />
                <span className="icon">
                  <Envelope className="input-svg-icon" />
                </span>
              </div>
            </div>
            <div className="input-group">
              <label htmlFor="password">{t('passwordLabel')}</label> {/* MODIFICACIÓN */}
              <div className="input-with-icon">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isSubmitting} 
                />
                <span
                  className="icon"
                  onClick={!isSubmitting ? () => setShowPassword(!showPassword) : undefined} 
                  aria-label={showPassword ? t('hidePasswordAriaLabel') : t('showPasswordAriaLabel')} // MODIFICACIÓN
                  style={{ cursor: isSubmitting ? 'default' : 'pointer' }} 
                >
                  {showPassword ? (
                    <EyeSlash className="input-svg-icon" />
                  ) : (
                    <Visibility className="input-svg-icon" />
                  )}
                </span>
              </div>
            </div>
            <div className="options-row">
              <label className={isSubmitting ? 'disabled-label' : ''}> 
                <span className="container">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)} 
                    style={{ opacity: 0, position: 'absolute' }}
                    disabled={isSubmitting} 
                  />
                  <span className="check" />
                </span>
                {t('rememberMeLabel')} {/* MODIFICACIÓN */}
              </label>
              {isSubmitting ? (
                <span className="forgot-password-link disabled-link">{t('forgotPasswordLink')}</span> // MODIFICACIÓN
              ) : (
                <RouterLink to="/forgot-password" className="forgot-password-link">
                  {t('forgotPasswordLink')} {/* MODIFICACIÓN */}
                </RouterLink>
              )}
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? t('signingInButton') : t('signInButton')} {/* MODIFICACIÓN */}
            </button>
            {error && <p className="login-error-message">{error}</p>} {/* El mensaje de error ya se traduce en handleSubmit */}
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
// --- END OF FILE src/pages/LoginForm.jsx ---